import { render, staticRenderFns } from "./TreeNodeDialog.vue?vue&type=template&id=ba875f48&scoped=true&"
import script from "./TreeNodeDialog.vue?vue&type=script&lang=js&"
export * from "./TreeNodeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba875f48",
  null
  
)

export default component.exports